// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__27-Yz","resendInfoText":"OnGoingPaymentBox_resendInfoText__2aKQb"};